import { render } from "./ManualStepData.vue?vue&type=template&id=c0bdf8d0&scoped=true"
import script from "./ManualStepData.vue?vue&type=script&lang=js"
export * from "./ManualStepData.vue?vue&type=script&lang=js"

import "./ManualStepData.vue?vue&type=style&index=0&id=c0bdf8d0&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0bdf8d0"]])

export default __exports__